/**
 * Which requests the activity bar waits for: the router's page loads (RSC) and
 * server actions, but only those a person set off. A page that polls in the
 * background does the same requests every few seconds; the bar would never
 * rest. Prefetches are never shown.
 */
export const USER_INTENT_MS = 1_000

export function isUserActivity(headers: Headers, msSinceInput: number): boolean {
  if (msSinceInput > USER_INTENT_MS) return false
  if (headers.has('next-router-prefetch')) return false
  return headers.has('next-action') || headers.get('rsc') === '1'
}

/** The headers of a fetch call, whichever form they were given in. */
export function headersOf(input: RequestInfo | URL, init?: RequestInit): Headers {
  if (init?.headers !== undefined) return new Headers(init.headers)
  if (typeof Request !== 'undefined' && input instanceof Request) return input.headers
  return new Headers()
}
